import { API } from "@/lib/api";

const LIME = "#e2ff31";

const loadImage = (src) => new Promise((resolve) => {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = () => resolve(img);
  img.onerror = () => resolve(null);
  img.src = src;
});

const roundRect = (ctx, x, y, w, h, r) => {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
};

const fitFont = (ctx, text, maxW, start, weight, family) => {
  let size = start;
  do { ctx.font = `${weight} ${size}px ${family}`; size -= 2; } while (ctx.measureText(text).width > maxW && size > 18);
  return size + 2;
};

const LAYOUTS = {
  story: { w: 1080, h: 1920, cover: 820, coverY: 330, head: 104, headY: 1310, title: 62, brandY: 170, urlY: 1800 },
  square: { w: 1080, h: 1080, cover: 520, coverY: 120, head: 64, headY: 720, title: 44, brandY: 72, urlY: 1036 },
};

export async function renderSaleCard(track, kind = "story", { handle = "" } = {}) {
  const L = LAYOUTS[kind];
  await document.fonts?.ready;
  const c = document.createElement("canvas");
  c.width = L.w; c.height = L.h;
  const ctx = c.getContext("2d");

  ctx.fillStyle = "#0a0a0a"; ctx.fillRect(0, 0, L.w, L.h);
  const glow = ctx.createRadialGradient(L.w / 2, L.coverY + L.cover / 2, 40, L.w / 2, L.coverY + L.cover / 2, L.w * 0.75);
  glow.addColorStop(0, "rgba(226,255,49,0.22)"); glow.addColorStop(1, "rgba(226,255,49,0)");
  ctx.fillStyle = glow; ctx.fillRect(0, 0, L.w, L.h);
  for (let i = 0; i < 2200; i++) {
    ctx.fillStyle = `rgba(255,255,255,${Math.random() * 0.035})`;
    ctx.fillRect(Math.random() * L.w, Math.random() * L.h, 2, 2);
  }

  ctx.textAlign = "center"; ctx.fillStyle = LIME;
  ctx.font = `700 ${kind === "story" ? 34 : 26}px 'JetBrains Mono', monospace`;
  ctx.fillText("CO MANN BEATS · EXCLUSIVE", L.w / 2, L.brandY);

  const x = (L.w - L.cover) / 2;
  const img = await loadImage(`${API}/cover/${track.id}?raw=1`);
  ctx.save();
  ctx.shadowColor = "rgba(0,0,0,0.6)"; ctx.shadowBlur = 60; ctx.shadowOffsetY = 24;
  roundRect(ctx, x, L.coverY, L.cover, L.cover, 36); ctx.fillStyle = "#1e1e1e"; ctx.fill();
  ctx.restore();
  ctx.save(); roundRect(ctx, x, L.coverY, L.cover, L.cover, 36); ctx.clip();
  if (img) {
    const s = Math.max(L.cover / img.width, L.cover / img.height);
    ctx.drawImage(img, x + (L.cover - img.width * s) / 2, L.coverY + (L.cover - img.height * s) / 2, img.width * s, img.height * s);
  }
  ctx.restore();
  ctx.strokeStyle = "rgba(226,255,49,0.55)"; ctx.lineWidth = 4; roundRect(ctx, x, L.coverY, L.cover, L.cover, 36); ctx.stroke();

  const head = "'Outfit', sans-serif";
  ctx.fillStyle = "#f3f4f6"; ctx.font = `800 ${L.head}px ${head}`;
  ctx.fillText("I JUST COPPED AN", L.w / 2, L.headY);
  ctx.fillStyle = LIME; ctx.fillText("EXCLUSIVE", L.w / 2, L.headY + L.head * 1.05);
  ctx.fillStyle = "#f3f4f6"; ctx.fillText("CO MANN BEAT", L.w / 2, L.headY + L.head * 2.1);

  const title = `“${track.title}”`;
  const size = fitFont(ctx, title, L.w - 160, L.title, 600, "'Manrope', sans-serif");
  ctx.fillStyle = "#9ca3af"; ctx.font = `600 ${size}px 'Manrope', sans-serif`;
  ctx.fillText(title, L.w / 2, L.headY + L.head * 2.1 + size * 1.6);

  if (handle) {
    ctx.fillStyle = LIME; ctx.font = `700 ${kind === "story" ? 40 : 30}px 'JetBrains Mono', monospace`;
    ctx.fillText(`prod. @${handle}`, L.w / 2, L.urlY - (kind === "story" ? 64 : 40));
  }
  ctx.fillStyle = "#6b7280"; ctx.font = `500 ${kind === "story" ? 30 : 24}px 'JetBrains Mono', monospace`;
  ctx.fillText(window.location.host || "comannbeats.com", L.w / 2, L.urlY);
  return c;
}

export const canvasToBlob = (c) => new Promise((res) => c.toBlob(res, "image/png"));
